namespace advisorop.components.servicer {
    

    class AdvisoryFirmListController {
        $router;

        dg: DevExpress.ui.dxDataGridOptions;
        public onAdvisoryFirmChanged: any;
        public advisoryFirms: Array<domains.IAdvisoryFirm>;

        static $inject = ["identityService", "servicerService", "advisoryFirmApi"];
        constructor(private identityService: services.IdentityService,
            private servicerService: services.ServicerService,
            private advisoryFirmApi: services.AdvisoryFirmApi) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "AdvisorFirms"
                },
                bindingOptions: {
                    dataSource: "vm.advisoryFirms"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "350px",
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                //stateStoring: {
                //    enabled: true,
                //    type: "localStorage",
                //    storageKey: "dgAdvisorsSettings"
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: 'Search...'
                },
                columns: [
                    { dataField: 'advisoryFirmName', caption: 'Name', width: 250, cellTemplate: 'advisoryFirmName' },
                    { dataField: 'companyGroup.companyName', caption: 'Company Group Name', width: 120, visible: true },
                    { dataField: 'tinForPublic', caption: 'TIN', width: 140, visible: false },
                    { dataField: 'contactFullName', caption: 'Contact', visible: false },
                    { dataField: 'fullAddress', caption: 'Address' },                    
                    { dataField: 'contactEmail', caption: 'E-mail', visible: false },
                    { dataField: 'id', caption: '#', cellTemplate: 'btnActions', visible: false }
                ],
                selection: {
                    mode: 'single',
                    showCheckBoxesMode: 'onClick'
                },
                onSelectionChanged: function (selectedItems) {
                    var data = selectedItems.selectedRowsData[0];
                    if (data) {
                        this.vm.onAdvisoryFirmChanged({ id: data.id });
                    }
                }
            };

        }
        
        getAdvisoryFirms(): void {
            this.advisoryFirmApi.getAdvisoryFirms()
                .then(data => {
                    this.advisoryFirms = data.data;
                }, err => {
                    toastr.error("Advisory Firm ERROR " + err.status + " " + err.data );
                });
        }
        
        $onInit(): void {
            this.getAdvisoryFirms();
        }

        $routerOnActivate(next, previous) {
        }
    }



    class AdvisoryFirmList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {    
                "$router": "<",
                onAdvisoryFirmChanged: "&"                            
            };
            this.controller = AdvisoryFirmListController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/advisory-firm-list.html';            
        }
    }
    angular.module(Constants.APP).component("advisoryFirmList", new AdvisoryFirmList());


}